'use strict';

/* globals define, RELATIVE_PATH_TRIMMED, $, socket, app, ajaxify, detailsPage */

define('group-container', ['alerts'], function (alerts) {
	var	GroupContainer = {};

	var actualGetter = null;

	var getters = [
		{
			pages: [
				'category',
				'topic',
			],
			getDetails: getDetailsFromCategory,
		},
		{
			pages: [
				'groups/invitations',
				'groups/settings/category',
				'board/board',
				'board/boards-list',
				'lesson/lesson',
				'lesson/lesson-editor',
				'lesson/lesson-analytics',
				'lesson/lessons-list',
				'survey/survey',
				'survey/survey-editor',
				'survey/surveys-list',
				'survey/survey-results',
				'game/games-list',
				'memory-game',
				'groups/care-calculator',
				'course/course',
				'course/course-editor',
				'course/coruse-analytics',
				'course/courses-list',
			],
			getDetails: getDetailsFromGroup,
		},
		{
			pages: [
				'groups/details',
				'groups/settings-page',
			],
			getDetails: getDetailsDirectlyFromGroup,
		},
		{
			pages: [
				'organizations/details',
				'organizations/settings',
			],
			getDetails: getDetailsDirectlyFromOrganization,
		},
	];

	GroupContainer.getDetails = function (tplUrl) {
		var getter = $.grep(getters, function (getter) {
			return $.inArray(tplUrl, getter.pages) >= 0;
		})[0];

		if (getter && getter !== actualGetter) {
			getter.getDetails();
			actualGetter = getter;
		} else if (!getter && actualGetter) {
			resetGroupColorTheme();
			actualGetter = null;
		}
	};

	function getDetailsFromCategory() {
		socket.emit('plugins.groupsExtendedCategories.getCategoryGroupDetails', { cid: ajaxify.data.cid }, customizeGroupFromReceivedData);
	}

	function getDetailsFromGroup() {
		socket.emit('plugins.groupsSockets.getGroupDetails', { name: ajaxify.data.group.name }, customizeGroupFromReceivedData);
	}

	function customizeGroupFromReceivedData(error, group) {
		if (error) {
			return alerts.error(error.message);
		}

		if (!group) return;

		customizeContainer(group.groupColor, group.name, getGroupUrl(group.slug));

		// changeBreadcrumbs(group.name, getGroupUrl(group.slug));
	}

	function getDetailsDirectlyFromGroup() {
		var groupColor = ajaxify.data.group.groupColor || detailsPage.getDefaultGroupColor();
		var groupName = ajaxify.data.group.name;

		customizeContainer(groupColor, groupName, getGroupUrl(ajaxify.data.group.slug));
	}

	function getDetailsDirectlyFromOrganization() {
		customizeContainer(ajaxify.data.organization.organizationColor, ajaxify.data.organization.name, getOrganizationUrl());
	}

	function customizeContainer(color, name, url) {
		$('.logo .brand-logo').css('display', 'none');
		$('.logo .title').css('display', 'block');
		$('.logo .title').attr('href', url);
		$('.logo .title').html('<span>' + name + '</span>');

		setContainerColorToTheme(color);
	}

	function getDefaultGroupColor() {
		return '#333451';
	}

	function getGroupUrl(slug) {
		return '/' + RELATIVE_PATH_TRIMMED + '/groups/' + slug;
	}

	function getOrganizationUrl() {
		return '/' + RELATIVE_PATH_TRIMMED + '/organization/' + ajaxify.data.organization.id + '/' + ajaxify.data.organization.slug;
	}

	function setContainerColorToTheme(color) {
		var selectors = ['#header', '.groups .card-header.ch-alt:not(.keep-color)'];

		$.each(selectors, function (index, value) {
			$(value).css('background-color', color);
		});
	}

	function resetGroupColorTheme() {
		$('.logo .brand-logo').css('display', 'block');
		$('.logo .title').css('display', 'none');

		setContainerColorToTheme(getDefaultGroupColor());
	}

	return GroupContainer;
});
